import { useEntityAPI } from '../../../redux/entity-api.hook';
import { requestSourceAPI } from '../redux/request-sources.slice';

export function useRequestSources() {
  return useEntityAPI(requestSourceAPI);
}
